import React from 'react';

const TooltipIkon = () => (
	<svg width="30" height="30" viewBox="-1 -1 32 32" fill="#fff" xmlns="http://www.w3.org/2000/svg">
		<path d="M14.0743 20V12.144H15.9143V20H14.0743ZM15.0023 10.768C14.6716 10.768 14.3996 10.672 14.1863 10.48C13.9729 10.288 13.8663 10.0373 13.8663 9.728C13.8663 9.41867 13.9729 9.168 14.1863 8.976C14.3996 8.77333 14.6716 8.672 15.0023 8.672C15.3329 8.672 15.6049 8.77333 15.8183 8.976C16.0316 9.168 16.1383 9.41867 16.1383 9.728C16.1383 10.0373 16.0316 10.288 15.8183 10.48C15.6049 10.672 15.3329 10.768 15.0023 10.768Z" fill="black" />
		<path d="M15 29C7.26801 29 1 22.732 1 15H-1C-1 23.8366 6.16344 31 15 31V29ZM29 15C29 22.732 22.732 29 15 29V31C23.8366 31 31 23.8366 31 15H29ZM15 1C22.732 1 29 7.26801 29 15H31C31 6.16344 23.8366 -1 15 -1V1ZM15 -1C6.16344 -1 -1 6.16344 -1 15H1C1 7.26801 7.26801 1 15 1V-1Z" fill="#D8D4D7" />
	</svg>
);

export default TooltipIkon;
